import { globalInfo } from "../env/util"

export const TIMEOUT = 3000
function isPromise(obj: any) {
  return (
    !!obj &&
    (typeof obj === "object" || typeof obj === "function") &&
    typeof obj.then === "function"
  )
}
function isRegExp(value: unknown): Boolean {
  return Object.prototype.toString.call(value) === "[object RegExp]"
}

/**
 * 拦截器执行
 * @param interceptors  拦截器栈
 * @param response NetConfig | Response
 */
export async function interceptorNet<T>(
  interceptors: TInterceptors<T>[],
  response: T,
  config?: NetRequest
): Promise<T> {
  if (!interceptors?.length) return response
  let p: any = response
  const uses = interceptors.map((item) => item?.use)
  if (uses?.length) {
    for (const use of uses) {
      try {
        p = config ? use(p, config) : use(p)
        if (isPromise(p)) {
          p = await p
        }
      } catch { }
    }
  }
  return p
}

export function exclude(obj: { [key: string]: any }, fields: string[]) {
  const objData: { [key: string]: any } = {}
  Object.keys(obj).forEach((key) => {
    if (fields.includes(key)) return
    objData[key] = obj[key]
  })
  return objData
}
/**
 * 判读是否有urlPrarms
 * @param config
 */
export function hasUrlParams<T extends NetRequest>(config: T): boolean {
  const { urlParams = {}, url = "" } = config
  if (!Object.keys(urlParams)?.length) return false
  const testReg = /(\{|\})/g
  if (!testReg.test(url)) return false
  if (url.indexOf("?") === -1) return true
  if (url.indexOf("?") < url.indexOf("{")) return false
  return true
}
/**
 * 解析url
 * @param url
 */
function analyseURL(url: string) {
  // const regUrl = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
  // if (!regUrl.test(url)) throw Error('Invalid url')
  // if (!regUrl.test(url)) return [url, '']
  let index = url.indexOf("?")
  index = index > -1 ? index : url.length
  const path = url.slice(0, index)
  const search = url.slice(index) || ""
  return { path, search }
}
/**
 * 存在urlParams的情况下，动态替换url路径
 * @param config
 */
export function replaceURL<T extends NetRequest>(config: T) {
  const { urlParams = {}, url = "" } = config
  let { path, search } = analyseURL(url)
  // let { pathname: path, search } = new URL(url)
  const testReg = /(\{|\})/g
  Object.keys(urlParams).forEach((key) => {
    const reg = new RegExp("{" + key + "}", "g")
    path = path.replace(reg, urlParams[key])
  })
  if (testReg.test(path)) throw new Error("Invalid urlParams: " + url)
  config.url = path + search
  return config
}

/**
 * format 数据转成字符串。防止空集合的情况
 * @param dataexport function loignRule<T extends NetRequest>(config: T): Boolean {
  //判断是否开启了登录鉴权，init的参数传递
  //if (config.islogin) return true
  return false
}

 */
function handleRequestData(data: { [key: string]: any }) {
  if (data === null || data === undefined || !data) return ""
  const t = typeof data
  if (["string", "number", "boolean"].includes(t)) return data
  if (t === "object" && Object.keys(data)?.length) {
    let str = ""
    Object.keys(data).forEach((key, index) => {
      str += `${index === 0 ? "" : "&"}${key}=${encodeURIComponent(data[key])}`
    })
    return str
  }
}
/**
 * 处理不同method下 query和body的差异
 * GET: url = url + query + body
 * POST: url = url + query
 */
export function withQuery(url: string, query = "", data?: unknown) {
  data = handleRequestData(data)
  query = query ? query : ""
  const flag =
    url.indexOf("?") === -1 && query.length ? "?" : query.length ? "&" : ""
  return `${url}${flag}${query}${data ? "&" + data : ""}`
}

/**
 * 拦截器栈过滤
 * @param interceptors 拦截器栈
 * @param config NetConifg | Response
 */
export async function interceptFilter<T extends NetRequest>(
  interceptors: TInterceptors<T>[],
  config?: T
): Promise<TInterceptors<T>[]> {
  try {
    if (!interceptors.length) return []
    const res = []
    for (const item of interceptors) {
      if (isRegExp(item.rule) && item.rule?.test(config.url)) {
        res.push(item)
      } else if (typeof item.rule === "function") {
        let ans = item.rule(config)
        if (isPromise(ans)) ans = await ans
        if (ans) res.push(item)
      }
    }
    return res
  } catch (e) {
    return e
  }
}

export const RegURL =
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
/**
 * 错误处理
 */
export function createResponseError(response: NetResult<any>): NetResult<any> {
  const { headers, status, url, body } = response || {}
  let res = body
  if (status < 200 || status > 299) {
    res = `request error: ${status} ${url}`
  }
  return {
    headers,
    status,
    body: res,
    url,
  }
}

/**
 * 当前接口是否为动态化
 * @param url
 * @param pathParams
 * @returns
 */
function disposeUrlDynamic(url: string, pathParams: { [key: string]: any }) {
  if (!pathParams) return url
  let tempUrl = url
  Object.keys(pathParams).map((item) => {
    tempUrl = tempUrl.replace(`{${item}}`, pathParams[item])
  })
  return tempUrl
}

/**
 * JSON 序列化 uriParams
 * @param data
 * @returns
 */
function getAsUriParameters(data: { [key: string]: any }) {
  let url = ""
  for (const prop in data) {
    url += encodeURIComponent(prop) + "=" + encodeURIComponent(data[prop]) + "&"
  }
  return url.substring(0, url.length - 1)
}
/**
 * 处理接口请求数据
 * @param url
 * @param method
 * @param GetWaySetConfig
 * @param userRequestBody
 * @returns
 */
export function forgeRequest(
  url: string,
  method: string,
  GetWaySetConfig: { urlDynamic: unknown },
  userRequestBody?: { pathParams?: {}; body?: {}; header?: {} }
) {
  let { urlDynamic } = GetWaySetConfig || {}
  const { pathParams = {}, body = {}, header = {} } = userRequestBody || {}
  const tempRequestInfo: any = {
    uri: url,
    method: method,
    header: {
      "content-type": "application/json",
      ...header,
    },
    body: null,
  }
  if (typeof urlDynamic === "string") urlDynamic = JSON.parse(urlDynamic)
  if (urlDynamic && userRequestBody) {
    tempRequestInfo.uri = disposeUrlDynamic(url, pathParams)
  }
  if (method === "post") {
    tempRequestInfo["body"] = body
  } else {
    tempRequestInfo.uri =
      tempRequestInfo.uri +
      (tempRequestInfo.uri ? "?" : "") +
      getAsUriParameters(body)
  }
  return tempRequestInfo
}

// 统一修改header
export function setHeaders<T extends NetRequest>(config: T) {
  const data = {
    "MAX-COUNTRY": globalInfo.get("country") || "unknow",
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      ...data,
    },
  }
}

// 统一httpData中header的key小写
export function headerFormatRule<T extends NetRequest>(config: T): boolean {
  return config?.data?.httpData ? true : false
}
export function headerFormat<T extends NetRequest>(config: T) {
  const header = config.data.httpData.header
  if (header) {
    const _header: { [key: string]: any } = {}
    for (const key in header) {
      _header[key.toLowerCase()] = header[key]
    }
    config.data.httpData.header = _header
  }
  return config
}